// Check if franchises is include in the list of Honda or Acura
// franchise = [{name: 'acura'}, {name: 'honda'}]
export const isHondaOrAcuraProfile = (franchises) => {
	if (
		!Array.isArray(franchises) ||
		franchises.length === 0 ||
		franchises.length > 1
	) {
		return false;
	}

	const matchFranchise = ['acura', 'honda'];

	const isHondaOrAcura = franchises.some(
		(franchise) =>
			franchise &&
			matchFranchise.includes(franchise.name?.toLowerCase()?.trim())
	);

	return isHondaOrAcura;
};
